module.exports = "<div class=\"register-buttons\">\r\n    <a class=\"btn btn-warning upgrade-button upgrade-cta\" href=\"$UpgradeLink\">Upgrade</a>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/templates/hubspot-upgrade-button.html
// module id = 440
// module chunks = 1